export class TargetURL {
  get() {
    /* return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? "https://localhost:5050/api" : "https://www.alphaomega.com.mx/AOLBackend/api" */
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
      ? 'https://localhost:5041/api'
      : 'https://alphaomega.gemcousa.solutions/AOLBackend/api'
  }
}
